import { handleActions } from 'redux-actions';
import { Actions } from '../constants';

import { SortingValue } from 'ha/types/SearchFilters';

export interface SortingState {
  currentSorting: SortingValue;
  indexes?: { [key in SortingValue]: string };
}

export default handleActions<SortingState, { sorting?: SortingValue }>(
  {
    [Actions.UPDATE_SEARCH_PARAMS]: (state, { payload: { sorting } }) => {
      if (!state.indexes || !sorting || sorting === state.currentSorting) {
        return state;
      }

      return {
        ...state,
        currentSorting: sorting,
      };
    },
  },
  {
    currentSorting: SortingValue.BestMatch,
  },
);
